<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>Who Governs?</h1>
<h1 class="bk1"><i>Presidents, Public Opinion, and Manipulation</i></h1>
<p class="bkau"><a class="page"></a><span class="sm">JAMES</span> <span class="sm">N.</span> <span class="sm">DRUCKMAN</span> <span class="sm">AND</span> <span class="sm">LAWRENCE</span> <span class="sm">R.</span> <span class="sm">JACOBS</span></p>
<p class="bkpub"><a class="page"></a><span class="sm">THE</span> <span class="sm">UNIVERSITY</span> <span class="sm">OF</span> <span class="sm">CHICAGO</span> <span class="sm">PRESS</span></p>
<p class="bkpub1"><a class="page"></a><span class="sm">CHICAGO</span> <span class="sm">AND</span> <span class="sm">LONDON</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-druckman-jacobs-0004.vue?027cf66e